import React from 'react';
import Image from 'next/image';

import {Text, Toggle} from '#component/base';
import {ProductRowProps} from '#component/page/Profile/components/ManagePlanTab/SubscriptionManager/SubscriptionManager.types';
import {useViewportSize} from '#hook';

import * as css from './ProductRow.css';

export const ProductRow = ({
  image,
  title,
  value,
  discount,
  subscribed,
  membershipIncluded,
  onChange,
}: ProductRowProps) => {
  const {isDesktop} = useViewportSize();
  const imageSize = isDesktop ? 80 : 60;

  const valueWithDiscount = (value - (value * discount) / 100).toFixed(2);
  const isDiscounted = discount > 0 && !membershipIncluded;
  const textColor = isDiscounted ? 'dustyGray' : 'doveGray';

  return (
    <div className={css.ProductRowContainer}>
      <div className={css.ImageWrapper}>
        <Image width={imageSize} height={imageSize} src={image} alt={title} />
      </div>
      <div className={css.TitleWrapper}>
        <Text variant="heading3" className={css.TextTitleStyles} color="burgundy">
          {title}
        </Text>
        <div>
          <Text
            color={textColor}
            className={`${isDiscounted ? css.LineThrough : ''} ${css.TextValueStyles}`}>
            {membershipIncluded ? 'Included in Membership' : `$${value}`}
          </Text>
          {isDiscounted && (
            <Text className={css.TextValueStyles} color="eggplant">
              {' '}
              ${valueWithDiscount}/mo
            </Text>
          )}
          {!isDiscounted && !membershipIncluded && (
            <Text className={css.TextValueStyles} color={textColor}>
              /mo
            </Text>
          )}
        </div>
      </div>
      <div>
        <Toggle checked={subscribed} onChange={onChange} />
      </div>
    </div>
  );
};
